<div class="row w-100 d-flex p-0 align-items-center">
  <div class="col-4 firstcol text-truncate">
    {{request.jobName}}
  </div>
  <div class="col-2 text-truncate" translate="Type.{{requestType}}">
  </div>
  <div class="col-1 text-truncate" [ngClass]="{'col-4': !request.workgroup || request.workgroup === '' }">
    <app-request-credit-summary [requestGuid]="request.id"></app-request-credit-summary>
  </div>
  <div class="col-2 text-truncate" *ngIf="request.workgroup">
    {{request.workgroupName}}
  </div>
  <div class="col-1 text-truncate" *ngIf="request.workgroup && MaxClearnaceIsNotOne()">
    {{request.clearancelevel}}
  </div>
  <div class="col-2 text-truncate request-id"><em class="bi bi-files float-end cursor-pointer copy-icon"
      aria-hidden="true" (click)="copyToClipboard()"></em>
      {{ request.id }}
  </div>
</div>